
const i18nConfig = {
	"请选择": {
		"zh-CN": "请选择",
		"zh-TW": "請選擇",
		"en": "Please select",
		"ja-JP": "選んでください"
	},
	"正在加载...": {
		"zh-CN": "正在加载...",
		"zh-TW": "正在加載...",
		"en": "Loading...",
		"ja-JP": "読み込み中"
	},
	"获取表单失败，请检查网络。": {
		"zh-CN": "获取表单失败，请检查网络。",
		"zh-TW": "獲取表單失敗，請檢查網絡。 ",
		"en": "Failed to get the form, please check the nezh-TWork. ",
		"ja-JP": "フォームを取得できませんでした。ネットワークを確認してください。"
	},
	"表单": {
		"zh-CN": "表单",
		"zh-TW": "表單",
		"en": "Form",
		"ja-JP": "フォーム"
	},
	"表单提交...": {
		"zh-CN": "表单提交...",
		"zh-TW": "表單提交...",
		"en": "Form submission...",
		"ja-JP": "フォーム送信..."
	},
	"提交成功": {
		"zh-CN": "提交成功",
		"zh-TW": "提交成功",
		"en": "Submit Successful",
		"ja-JP": "コミット成功"
	},
	"支付二维码": {
		"zh-CN": "支付二维码",
		"zh-TW": "支付二維碼",
		"en": "Pay QR Code",
		"ja-JP": "QRコードで支払う"
	},
	"关闭": {
		"zh-CN": "关闭",
		"zh-TW": "關閉",
		"en": "Close",
		"ja-JP": "閉鎖"
	},
	"付款成功": {
		"zh-CN": "付款成功",
		"zh-TW": "付款成功",
		"en": "Payment Successful",
		"ja-JP": "成功した支払い"
	},
	"验证码": {
		"zh-CN": "验证码",
		"zh-TW": "驗證碼",
		"en": "Verification Code",
		"ja-JP": "検証コード"
	},
	"不再提示": {
		"zh-CN": "不再提示",
		"zh-TW": "不再提示",
		"en": "Don't Prompt Anymore",
		"ja-JP": "二度と思い出させないでください"
	},
	"手机浏览器只能提交表单，无法进行支付": {
		"zh-CN": "手机浏览器只能提交表单，无法进行支付",
		"zh-TW": "手機瀏覽器只能提交表單，無法進行支付",
		"en": "Mobile browser Can only submit the form, cannot make the payment",
		"ja-JP": "モバイルブラウザはフォームの送信のみが可能で、支払いはできません"
	},
	"取消": {
		"zh-CN": "取消",
		"zh-TW": "取消",
		"en": "Cancel",
		"ja-JP": "キャンセル"
	},
	"确定": {
		"zh-CN": "确定",
		"zh-TW": "確定",
		"en": "OK",
		"ja-JP": "もちろん"
	},
	"提交并支付": {
		"zh-CN": "提交并支付",
		"zh-TW": "提交並支付",
		"en": "Submit and pay",
		"ja-JP": "提出して支払う"
	},
	"请输入": {
		"zh-CN": "请输入",
		"zh-TW": "請輸入",
		"en": "Please enter",
		"ja-JP": "入ってください"
	},
	"该项是必填项": {
		"zh-CN": "该项是必填项",
		"zh-TW": "該項是必填項",
		"en": "This item is required",
		"ja-JP": "このアイテムは必須です"
	},
	"格式不正确": {
		"zh-CN": "格式不正确",
		"zh-TW": "格式不正確",
		"en": "The format is incorrect",
		"ja-JP": "間違ったフォーマット"
	},
	"不能为空": {
		"zh-CN": "不能为空",
		"zh-TW": "不能為空",
		"en": "Cannot be empty",
		"ja-JP": "空にすることはできません"
	},
	"手机号格式不正确": {
		"zh-CN": "手机号格式不正确",
		"zh-TW": "手機號格式不正確",
		"en": "Mobile phone number format is not Correct",
		"ja-JP": "電話番号の形式が正しくありません"
	},
	"请选择定位": {
		"zh-CN": "请选择定位",
		"zh-TW": "請選擇定位",
		"en": "Please select a location",
		"ja-JP": "場所を選択してください"
	},
	"签到成功": {
		"zh-CN": "签到成功",
		"zh-TW": "簽到成功",
		"en": "Sign in successfully",
		"ja-JP": "正常にサインイン"
	},
	"表单提交成功": {
		"zh-CN": "表单提交成功",
		"zh-TW": "表單提交成功",
		"en": "Form submission succeeded",
		"ja-JP": "フォームが正常に送信されました"
	},
	"请输入多选备注": {
		"zh-CN": "请输入多选备注",
		"zh-TW": "請輸入多選備註",
		"en": "Please enter multiple choice remarks",
		"ja-JP": "複数の選択肢のコメントを入力してください"
	},
	"上传失败": {
		"zh-CN": "上传失败",
		"zh-TW": "上傳失敗",
		"en": "Upload failed",
		"ja-JP": "アップロードに失敗しました"
	},
	"重传": {
		"zh-CN": "重传",
		"zh-TW": "重傳",
		"en": "Retransmit",
		"ja-JP": "再送信"
	},
	"超过文件大小限制": {
		"zh-CN": "超过文件大小限制",
		"zh-TW": "超過文件大小限制",
		"en": "Exceeded file size limit",
		"ja-JP": "ファイルサイズの制限を超えました"
	},
	"上传附件": {
		"zh-CN": "上传附件",
		"zh-TW": "上傳附件",
		"en": "Upload attachments",
		"ja-JP": "添付ファイルをアップロード"
	},
	"该图片已在列表中": {
		"zh-CN": "该图片已在列表中",
		"zh-TW": "該圖片已在列表中",
		"en": "The picture is already in the list",
		"ja-JP": "画像は添付ファイルとしてリストにアップロードされています"
	},
	"超过图片大小限制": {
		"zh-CN": "超过图片大小限制",
		"zh-TW": "超過圖片大小限制",
		"en": "Exceeds the picture size limit",
		"ja-JP": "画像サイズの制限を超えました"
	},
	"图形验证码": {
		"zh-CN": "图形验证码",
		"zh-TW": "圖形驗證碼",
		"en": "Graphic verification code",
		"ja-JP": "キャプチャ"
	},
	"验证码输入不正确": {
		"zh-CN": "验证码输入不正确",
		"zh-TW": "驗證碼輸入不正確",
		"en": "The verification code is entered incorrectly",
		"ja-JP": "パスワードが正しくありません"
	},
	"请输入验证码": {
		"zh-CN": "请输入验证码",
		"zh-TW": "請輸入驗證碼",
		"en": "Please enter the verification code",
		"ja-JP": "認証コードを入力してください"
	},
	"验证码是必填项": {
		"zh-CN": "验证码是必填项",
		"zh-TW": "驗證碼是必填項",
		"en": "The verification code is required",
		"ja-JP": "確認コードが必要です"
	},
	"验证输入不正确!": {
		"zh-CN": "验证输入不正确!",
		"zh-TW": "驗證輸入不正確!",
		"en": "Verify that the input is incorrect!",
		"ja-JP": "検証入力が正しくありません！"
	},
	"请输入写字楼、街道、公司名称": {
		"zh-CN": "请输入写字楼、街道、公司名称",
		"zh-TW": "請輸入寫字樓、街道、公司名稱",
		"en": "Please enter the office building, street, company name",
		"ja-JP": "オフィスビル、通り、会社名を入力してください"
	},
	"重新定位": {
		"zh-CN": "重新定位",
		"zh-TW": "重新定位",
		"en": "Repositioning",
		"ja-JP": "再配置"
	},
	"选择定位": {
		"zh-CN": "选择定位",
		"zh-TW": "選擇定位",
		"en": "Select positioning",
		"ja-JP": "ターゲティングを選択"
	},
	"定位中...": {
		"zh-CN": "定位中...",
		"zh-TW": "定位中...",
		"en": "Positioning...",
		"ja-JP": "ポジショニング..."
	},
	"定位失败": {
		"zh-CN": "定位失败",
		"zh-TW": "定位失敗",
		"en": "Locate failed",
		"ja-JP": "場所が失敗しました"
	},
	"公司企业|商务住宅|政府机构及社会团体": {
		"zh-CN": "公司企业|商务住宅|政府机构及社会团体",
		"zh-TW": "公司企業|商務住宅|政府機構及社會團體",
		"en": "Company enterprise|Commercial Housing|Government Agency and Social Group",
		"ja-JP": "企業|企業住宅|政府機関および社会組織"
	},
	"搜索附近地址": {
		"zh-CN": "搜索附近地址",
		"zh-TW": "搜索附近地址",
		"en": "Search nearby address",
		"ja-JP": "近くの住所を検索する"
	},
	"附近地址": {
		"zh-CN": "附近地址",
		"zh-TW": "附近地址",
		"en": "Nearby address",
		"ja-JP": "近くの住所"
	},
	"正在上传签名，请稍后提交": {
		"zh-CN": "正在上传签名，请稍后提交",
		"zh-TW": "正在上傳簽名，請稍後提交",
		"en": "Uploading signature, please submit later",
		"ja-JP": "署名をアップロードします。後で送信してください"
	},
	"签名": {
		"zh-CN": "签名",
		"zh-TW": "簽名",
		"en": "Signature",
		"ja-JP": "サイン"
	},
	"上传签名失败": {
		"zh-CN": "上传签名失败",
		"zh-TW": "上傳簽名失敗",
		"en": "Upload signature failed",
		"ja-JP": "署名のアップロードに失敗しました"
	},
	"选择日期": {
		"zh-CN": "选择日期",
		"zh-TW": "選擇日期",
		"en": "Select date",
		"ja-JP": "日付を選択"
	},
	"选择时间": {
		"zh-CN": "选择时间",
		"zh-TW": "選擇時間",
		"en": "Select time",
		"ja-JP": "選考期間"
	},
	"请输入单选备注": {
		"zh-CN": "请输入单选备注",
		"zh-TW": "請輸入單選備註",
		"en": "Please enter a single-select remark",
		"ja-JP": "ラジオのコメントを入力してください"
	},
	"元": {
		"zh-CN": "元",
		"zh-TW": "元",
		"en": "Yuan",
		"ja-JP": "元"
	},
	"万": {
		"zh-CN": "万",
		"zh-TW": "萬",
		"en": "Ten thousand",
		"ja-JP": "万"
	},
	"亿": {
		"zh-CN": "亿",
		"zh-TW": "億",
		"en": "One hundred million",
		"ja-JP": "億"
	},
	"兆": {
		"zh-CN": "兆",
		"zh-TW": "兆",
		"en": "Trillion",
		"ja-JP": "トリリオン"
	},
	"拾": {
		"zh-CN": "拾",
		"zh-TW": "拾",
		"en": "Ten",
		"ja-JP": "選び出す"
	},
	"佰": {
		"zh-CN": "佰",
		"zh-TW": "佰",
		"en": "Hundred",
		"ja-JP": "バイ"
	},
	"仟": {
		"zh-CN": "仟",
		"zh-TW": "仟",
		"en": "Thousand",
		"ja-JP": "千"
	},
	"壹": {
		"zh-CN": "壹",
		"zh-TW": "壹",
		"en": "One",
		"ja-JP": "壱"
	},
	"贰": {
		"zh-CN": "贰",
		"zh-TW": "貳",
		"en": "zh-TWo",
		"ja-JP": "その2"
	},
	"叁": {
		"zh-CN": "叁",
		"zh-TW": "叁",
		"en": "Three",
		"ja-JP": "参"
	},
	"肆": {
		"zh-CN": "肆",
		"zh-TW": "肆",
		"en": "Four",
		"ja-JP": "肆"
	},
	"伍": {
		"zh-CN": "伍",
		"zh-TW": "伍",
		"en": "Five",
		"ja-JP": "伍"
	},
	"陆": {
		"zh-CN": "陆",
		"zh-TW": "陸",
		"en": "Six",
		"ja-JP": "陸"
	},
	"柒": {
		"zh-CN": "柒",
		"zh-TW": "柒",
		"en": "Seven",
		"ja-JP": "柒"
	},
	"捌": {
		"zh-CN": "捌",
		"zh-TW": "捌",
		"en": "Eight",
		"ja-JP": "つかむ"
	},
	"玖": {
		"zh-CN": "玖",
		"zh-TW": "玖",
		"en": "Nine",
		"ja-JP": "玖"
	},
	"角": {
		"zh-CN": "角",
		"zh-TW": "角",
		"en": "dime",
		"ja-JP": "かく"
	},
	"分": {
		"zh-CN": "分",
		"zh-TW": "分",
		"en": "cent",
		"ja-JP": "分"
	},
	"整": {
		"zh-CN": "整",
		"zh-TW": "整",
		"en": "full",
		"ja-JP": "整"
	}
}
  
export default i18nConfig


// WEBPACK FOOTER //
// ./src/assets/i18n.js